























































































































import {
  defineComponent,
  ref,
  computed,
  watch,
  Ref,
  reactive
} from '@vue/composition-api'
import { useRouter } from '@u3u/vue-hooks'
import UserAvatar from '@/components/UserAvatar.vue'
import MemberStatusBadge from '@/components/MemberStatusBadge.vue'
import { numberWithCommas } from '@/lib/utils'
import { useAxios } from '@vue-composable/axios'
import { useAuth } from '@/composables/useAuth'
import { AxiosBasicCredentials } from 'axios'

export default defineComponent({
  components: {
    UserAvatar,
    MemberStatusBadge
  },

  setup(_, { root }) {
    const { username, userToken } = useAuth()
    const auth = {
      username: username.value,
      password: userToken.value
    } as AxiosBasicCredentials

    const { route, router } = useRouter()
    const pageSize = 10
    const current = +(route.value.query['current'] ?? 1)
    const searchTerm = ref(route.value.query['q'] as string)

    const params = reactive({
      page: current,
      // eslint-disable-next-line
      page_size: pageSize,
      q: route.value.query['q']
    })

    const { data: result, loading, error, exec } = useAxios()

    watch(
      () => params,
      params => {
        exec({
          url: `${process.env.VUE_APP_MARKETING_API_BASE_URL}/api/admin/contacts`,
          method: 'GET',
          params,
          auth
        })
      },
      { deep: true, immediate: true }
    )

    watch(
      error,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred'
          })
        }
      },
      { immediate: true }
    )

    const data = computed(() => {
      const data = result.value
      if (data == null) {
        return { users: [], pagination: {} }
      }
      const pagination = {
        total: data.pagination.total_entries,
        pageSize: data.pagination.page_size,
        current: data.pagination.page_number
      }
      return {
        users: data.data,
        pagination
      }
    })

    const columns = [
      {
        title: '',
        dataIndex: 'avatar',
        scopedSlots: { customRender: 'avatar' },
        align: 'center'
      },
      {
        title: 'id',
        dataIndex: 'user_id'
      },
      {
        title: 'name',
        dataIndex: 'attrs.name'
      },
      {
        title: 'email',
        dataIndex: 'email'
      },
      {
        title: 'status',
        dataIndex: 'attrs.membership',
        scopedSlots: { customRender: 'status' }
      },
      {
        title: 'last seen at',
        dataIndex: 'attrs.last_seen'
      }
    ]

    const handleTableChange = ({ current }: { current: number }) => {
      router.push({
        path: route.value.path,
        query: { ...route.value.query, current: `${current}` }
      })
      params.page = current
    }

    /// Modal
    // eslint-disable-next-line
    const contact: Ref<null | any> = ref(null)
    const modalTitle = computed(() => {
      return `${contact.value?.attrs?.name ?? contact.value?.user_id}`
    })
    const modalVisible = ref(false)
    // eslint-disable-next-line
    const showModal = (val: any) => {
      contact.value = val
      modalVisible.value = true
    }
    const hideModal = () => {
      contact.value = null
    }

    const search = () => {
      router.push({
        path: route.value.path,
        query: { ...route.value.query, current: undefined, q: searchTerm.value }
      })
      params.page = 1
      params.q = searchTerm.value
    }

    watch(searchTerm, newVal => {
      if (newVal?.trim() === '') {
        search()
      }
    })

    const { loading: isImporting, exec: importCSV } = useAxios()
    // eslint-disable-next-line
    const importContacts = (e: any) => {
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      formData.append('file', files[0])
      formData.append('max', '2')

      importCSV({
        url: `${process.env.VUE_APP_MARKETING_API_BASE_URL}/api/admin/contacts/import`,
        method: 'POST',
        data: formData,
        auth
      }).then(
        () => {
          root.$notification.info({
            message: 'Import',
            description: 'Contacts are being imported asynchronously'
          })
        },
        // eslint-disable-next-line
        (error: any) => {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred during import'
          })
        }
      )
    }

    const handleOptionClick = (evt: { key: string }) => {
      switch (evt.key) {
        case 'import_csv':
          break
        case 'sync_mailjet':
          break
      }
    }

    return {
      searchTerm,
      search,

      numberWithCommas,

      handleTableChange,

      importContacts,
      handleOptionClick,
      isImporting,

      loading,
      data,
      columns,

      modalTitle,
      modalVisible,
      contact,
      showModal,
      hideModal
    }
  }
})
